<template>
    <span :class="bgColor" class="inline-block max-w-full truncate rounded-md px-4 leading-[30px] font-medium text-body">{{ groupName }}</span>
</template>
<script setup>
import { computed } from 'vue';
import { trans } from '@/mixins/i18n.js';

const props = defineProps({
    group: {
        type: String,
        validator: (value) => ['asset_check', 'preventative_maintenance', 'performance_data'].includes(value),
    },
    bgColor: {
        type: String,
        required: true,
    },
});

const groupName = computed(() => {
    switch (props.group) {
        case 'asset_check':
            return trans('qa.configuration.type.asset_check.short');
        case 'preventative_maintenance':
            return trans('qa.configuration.type.preventative_maintenance.short');
        case 'performance_data':
            return trans('qa.configuration.type.performance_data.short');
        default:
            return '';
    }
});
</script>
